// Libraries Imports
import React, { FC, useState } from "react";
import { Button, Select } from "../../commons";
import { mc } from "../../images";

// Local Imports
import { Wrapper, Tag, Counter } from "./styles";

// Common Imports

// Components Imports
import { pizza } from "../../images";

// API Imports
import { Product } from "../../components";
import { ProductPayload } from "../../api/types";
import { Check } from "../../images/icons";

// Other Imports

// Types
type OrderType = "pickup" | "delivery";

const Store: FC = () => {
  // Local variables

  // States
  const [order, setOrder] = useState<OrderType>("delivery");
  const [taglist, setTaglist] = useState<string[]>([]);
  const [branch, setBranch] = useState<string | undefined>();

  // Queries & Mutaions

  // Functions

  // Local Data

  const tags = ["برجر", "بيتزا"];

  const handleTaglist = (tag: string) => {
    const tags = Object.assign(taglist, []);
    console.log(tags.indexOf(tag) !== -1);
    if (tags.indexOf(tag) === -1) {
      setTaglist([...taglist, tag]);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const newTags = tags.splice(tags.indexOf(tag), 1);
      setTaglist(tags.splice(tags.indexOf(tag), 1));
    }
  };

  const product: ProductPayload = {
    name: "بيتزا",
    pic: pizza,
    price: "20",
    total: 20,
  };

  const getHeight = () => {
    return Math.round(2 / 2) * 266;
  };

  return (
    <Wrapper height={getHeight()} open={true}>
      <div className="banner">
        <img
          src="http://alicegren.fr/wp-content/uploads/2019/08/healthy-food.jpg"
          alt="banner"
          className="banner_img"
        />
        <img src={mc} alt="" className="store_logo" />
      </div>
      <div className="info">
        <div className={`delivery-settings ${order}`}>
          <button onClick={() => setOrder("delivery")} className="delivery-btn">
            الكل
          </button>
          <button onClick={() => setOrder("pickup")} className="pickup-btn">
            العروض
          </button>
        </div>
        <h3 className="store-name">مكدونالدز</h3>
        <div className="branch">
          <Select
            fullWidth
            name="الفروع"
            onChange={(e) => setBranch(e)}
            options={[
              {
                label: "أبو ظبي",
                value: "أبو ظبي",
                icon: (
                  <Check
                    className={`check ${branch === "أبو ظبي" && "selected"}`}
                  />
                ),
              },
              {
                label: "الشارقة",
                value: "الشارقة",
                icon: (
                  <Check
                    className={`check ${branch === "الشارقة" && "selected"}`}
                  />
                ),
              },
              {
                label: "دبي",
                value: "دبي",
                icon: (
                  <Check
                    className={`check ${branch === "دبي" && "selected"}`}
                  />
                ),
              },
            ]}
          />
        </div>
        <label className="status__open status">مفتوح</label>
      </div>
      <hr className="separator" />
      <div className="work-hours">
        <span>مواعيد الغلق والفتح</span>
        <div className="work-time">
          <label>
            <span>مفتوح من: </span>9:00 ص
          </label>
          <label>
            <span>يغلق عند: </span>10:00 م
          </label>
        </div>
      </div>
      <hr className="separator" />
      {/* <div className="pickup-address">
        <span>تسلم من</span>
        <label>عنوان المتجر لتسلم الطلب</label>
      </div>
      <div className="search">
        <h3 className="store-name">الفروع</h3>
      </div> */}
      <div className="list-container">
        {tags.map((tag, index) => {
          return (
            <div className="tags">
              <Tag
                key={index}
                onClick={() => handleTaglist(tag)}
                selected={taglist.indexOf(tag) !== -1}
              >
                {tag}
              </Tag>
            </div>
          );
        })}
      </div>
      <div className="products-list-container">
        <Product data={product} onSelect={() => {}} />
        <Product data={product} onSelect={() => {}} />
      </div>
      {/* <Button
        label="إفتح قائمة الطعام"
        onClick={() => {
          setOpen(true);
        }}
        disabled={store === ""}
      />
       */}
      <Button
        icon={
          <Counter>
            <div>
              <span>{200}</span>&nbsp;
              <span>&nbsp;ر.س</span>
            </div>
          </Counter>
        }
        label="مراجعة الطلب"
        onClick={() => {}}
      />
    </Wrapper>
  );
};

export default Store;
